/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@material-ui/core';
import axios from 'axios';
import confetti from 'canvas-confetti';
// eslint-disable-next-line import/no-unresolved
import { storeContext } from '../provider/Provider';
import GreenButton from '../../customUI/GreenButton';
import RedButton from '../../customUI/RedButton';

import { leadsActions } from '../../store/leads-reducer';

const { REACT_APP_FLASK_API_URL } = process.env;

const MobileLeadsCard = ({ row }) => {
  const [openDialog, setOpenDialog] = React.useState(false);

  const [settingStatus, setSettingStatus] = React.useState('won');
  const [email, setEmail] = React.useState(row.leadBody.email);
  const [fullName, setFullName] = React.useState(row.leadBody.fullName);
  const [phone, setPhone] = React.useState(row.leadBody.phone);
  const { dispatch } = React.useContext(storeContext);

  const [fullView, setFullview] = React.useState(false);
  const useStyles = makeStyles(() => ({
    mobileCard: {
      background: 'white',
      borderRadius: '16px',
      padding: 15,
      margin: 10,
      border: '3px white solid',
    },
    flexLine: {
      display: 'flex',
      alignItems: 'center',
      margin: '10px 0',
    },
    flexLineDefault: {
      display: 'flex',
      alignItems: 'center',
    },
  }));

  const handleClick = () => {
    setFullview(!fullView);
  };

  const handleStatusBtnClick = (newStatus) => {
    setSettingStatus(newStatus);
    setOpenDialog(true);
  };

  const handleSubmitStatusChange = () => {
    const data = { lead_uuid: row.uuid, status: settingStatus };
    if (email !== row.leadBody.email) {
      data.email = email;
    }
    if (fullName !== row.leadBody.fullName) {
      data.fullName = fullName;
    }
    if (phone !== row.leadBody.phone) {
      data.phone = phone;
    }
    axios.post(`${REACT_APP_FLASK_API_URL}/v1/leads/update`, data).then(() => {
      setOpenDialog(false);
    });
    if (settingStatus === 'won') {
      confetti({
        particleCount: 200,
        angle: 40,
        spread: 100,
        origin: { x: 0 },
        zIndex: 1200,
        colors: ['#00b5e2', '#ffffff', '#ffa400', '#bb0000'],
      });
      confetti({
        particleCount: 200,
        angle: 140,
        spread: 100,
        origin: { x: 1 },
        zIndex: 1200,
        colors: ['#00b5e2', '#ffffff', '#ffa400', '#bb0000'],
      });
    }
    dispatch({
      type: leadsActions.LEADS_UPDATE_LEAD,
      payload: {
        ...row,
        status: settingStatus,
        leadBody: {
          ...row.leadBody,
          email,
          fullName,
          phone,
        },
      },
    });
  };

  const classes = useStyles();
  return (
    <>
      <div
        className={classes.mobileCard}
        key={row.leadBody.email}
        onClick={handleClick}
        aria-label="default box"
      >
        {fullView ? (
          <>
            <div className={classes.flexLine}>
              <div style={{ width: '20%', userSelect: 'none' }}>{`${new Date(
                row.createdAt
              ).toLocaleString('en-US', { month: 'short' })} ${new Date(
                row.createdAt
              ).getFullYear()}`}</div>
              <div style={{ width: '80%', userSelect: 'none' }}>{row.leadBody.fullName}</div>
            </div>
            <div
              style={{ background: '#00B4E0', height: '1px', width: '100%', margin: '10px 0' }}
            />
            {Object.entries(row.leadBody).map(([key, value]) => (
              <React.Fragment key={row.uuid + value}>
                <div className={classes.flexLine}>
                  <div style={{ width: '20%', userSelect: 'none' }}>{key}</div>
                  <div style={{ width: '80%', userSelect: 'none' }}>{value}</div>
                </div>
              </React.Fragment>
            ))}
            <div className={classes.flexLine}>
              <div style={{ width: '20%', userSelect: 'none' }}>
                {row.status === 'won' ? (
                  <GreenButton className={classes.squareButton} disabled>
                    Won
                  </GreenButton>
                ) : (
                  <GreenButton
                    className={classes.squareButton}
                    aria-label="change status to won"
                    onClick={() => {
                      handleStatusBtnClick('won');
                    }}
                  >
                    Won
                  </GreenButton>
                )}
              </div>
              <div style={{ width: '80%', userSelect: 'none' }}>
                {row.status === 'lost' ? (
                  <RedButton className={classes.squareButton} disabled>
                    Lost
                  </RedButton>
                ) : (
                  <RedButton
                    className={classes.squareButton}
                    aria-label="change status to lost"
                    onClick={() => {
                      handleStatusBtnClick('lost');
                    }}
                  >
                    Lost
                  </RedButton>
                )}
              </div>
            </div>
          </>
        ) : (
          <div className={classes.flexLineDefault}>
            <div style={{ width: '20%', userSelect: 'none' }}>{`${new Date(
              row.createdAt
            ).toLocaleString('en-US', { month: 'short' })} ${new Date(
              row.createdAt
            ).getFullYear()}`}</div>
            <div style={{ width: '80%', userSelect: 'none' }}>{row.leadBody.fullName}</div>
          </div>
        )}
      </div>
      <Dialog
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
        }}
        aria-labelledby="form-dialog-title"
      >
        {settingStatus === 'won' ? (
          <DialogTitle id="form-dialog-title">Lead Signed</DialogTitle>
        ) : (
          <DialogTitle id="form-dialog-title">Rejected</DialogTitle>
        )}

        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="email"
            label="Email Address"
            fullWidth
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
          <TextField
            margin="dense"
            id="full name"
            label="Full Name"
            fullWidth
            value={fullName}
            onChange={(e) => {
              setFullName(e.target.value);
            }}
          />
          <TextField
            margin="dense"
            id="phone"
            label="Phone"
            fullWidth
            value={phone}
            onChange={(e) => {
              setPhone(e.target.value);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenDialog(false);
            }}
            style={{ color: '#58595B' }}
          >
            Cancel
          </Button>
          {settingStatus === 'won' ? (
            <GreenButton aria-label="submit won" onClick={handleSubmitStatusChange}>
              Submit
            </GreenButton>
          ) : (
            <RedButton aria-label="submit lost" onClick={handleSubmitStatusChange}>
              Submit
            </RedButton>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MobileLeadsCard;
